module.exports = __webpack_public_path__ + "static/media/React_color_shades_generator.1c66e99e.PNG";